<app-banner [loading]="loading" [info]="true" [heading]="'Notifications'" [subHeading]="'View the notification details'">


  <div class="toolbar-content">

    <button class="btn btn-back" (click)="exit()">
      <i class="fa fa-arrow-left"></i>
      <span>dashboard</span>
    </button>

    <button *ngIf="!layout.state.fullscreen" (click)="layout.setFullscreen(true)" aria-label="Maximise" class="btn btn-back">
      <i class="fa fa-window-maximize"></i>
      <span>maximise</span>
    </button>

    <button *ngIf="layout.state.fullscreen" (click)="layout.setFullscreen(false)" aria-label="Maximise" class="btn btn-back">
      <i class="fa fa-window-restore"></i>
      <span>restore</span>
    </button>


  </div>

</app-banner>

<div class="content no-boxes fadein" *ngIf="!loading">

  <div class="row">
  <div class="col-md-6 mrg-btm-40">
    <div class="premises-notifications-common-details">
      <div class="details">
        <label>Owner name</label>
        <span>{{details?.ownerName}}</span>
      </div>
      <div class="details">
        <label>Date</label>
        <span>{{details?.date | utcDate}}</span>
      </div>
    </div>
  </div>
  </div>

  <div class="row">
  <div class="col-md-6 mrg-btm-40">
    <div class="premises-notifications-common-details">
      <div class="details">
        <label>Notification type</label>
        <span>{{ getNotificationType(details?.notificationType) }}</span>
      </div>
      <div class="details">
        <label>Title</label>
        <span>{{ details?.notificationTitle }}</span>
      </div>
    </div>
  </div>
  </div>

  <div class="row">
  <div class="col-md-12 mrg-btm-40">
    <div class="premises-notifications-common-details">
      <div class="notification-content">
        <label>Notification content</label>
        <div>

          <div *ngIf="details?.notificationType === NotificationType.RenewalWindowOpeningForPharmacyForCardBACS || details?.notificationType === NotificationType.RenewalWindowOpeningForPharmacyForDirectDebit"><p>View your letter here</p></div>
            
            <div *ngIf="details?.notificationType === NotificationType.PharmacyRenewalPaymentReminderForAll">
                
                <div *ngIf="details?.notificationData?.Count < 6 else showCount">
                  <p>Owner name: <b>{{details?.notificationData?.OwnerName}}</b></p>
                  <p>Pharmacy renewals outstanding</p>
                  <div *ngFor="let premise of details?.notificationData?.Premises; let i = index;">
                    <p>
                    Pharmacy registration number: <b>{{ premise.RegistrationNumber }}</b>
                    <br /> 
                    Pharmacy name: <b>{{ premise.PremiseName }}</b>
                    </p>
                  </div>
                </div>
                <ng-template #showCount>
                  <p>Owner name: <b>{{details?.notificationData?.OwnerName}}</b></p>
                  <p>Total number of premises for renewal: <b>{{details?.notificationData?.Count}}</b></p>
                </ng-template>

                <p>
                  Your pharmacy registration renewal is due by <b>{{ details?.notificationData?.RenewalDate }}</b>. Please complete any of the following   
                  steps that are still outstanding:  
                </p>
                <ul>
                  <li>complete your pharmacy renewal declarations  </li>
                  <li>pay your pharmacy registration renewal fee  </li>
                </ul>
                <p>
                        If you do not complete your pharmacy renewal declarations and pay your pharmacy   
                  renewal fee before your renewal due date, your pharmacy registration will be at risk, and   
                  we may take action that could lead to its removal from the register. If your pharmacy is   
                  removed, you would need to apply for restoration and pay a higher restoration fee before   
                  it can be returned to the register.  
                </p>
                <br/>
                <p>Regards,</p>
                <p>General Pharmaceutical Council</p>

            </div>
            
            <div *ngIf="details?.notificationType === NotificationType.PharmacyRenewalDeclarationReminderForDD">
                <div *ngIf="details?.notificationData?.Count < 6 else showCount">
                  <p>Owner name: <b>{{details?.notificationData?.OwnerName}}</b></p>
                  <p>Pharmacies selected:</p>
                  <div *ngFor="let premise of details?.notificationData?.Premises; let i = index;">
                    <p>
                    Pharmacy registration number: <b>{{ premise.RegistrationNumber }}</b>
                    <br /> 
                    Pharmacy name: <b>{{ premise.PremiseName }}</b>
                    </p>
                  </div>
                </div>
                <ng-template #showCount>
                  <p>Owner name: <b>{{details?.notificationData?.OwnerName}}</b></p>
                  <p>Total number of premises for renewal: <b>{{details?.notificationData?.Count}}</b></p>
                </ng-template>
                <p>
                  Your pharmacy currently has a direct debit in place for the payment of its registration renewal   
                  fees.      
                </p>
                <p>
                  In order to collect your pharmacy registration renewal fee by direct debit your pharmacy   
                  declarations need to be made by <b>{{ details?.notificationData?.DeclarationDeadline }}</b>. 
                </p>
                <p>
                      If the declarations are not made by this date, you will be required to complete your   
                  pharmacy renewal declarations and pay the outstanding renewal fee by card or BACS   
                  by <b>{{ notification?.data?.RenewalDate}}</b>
                </p>
                <br/>
                <p>Regards,</p>
                <p>General Pharmaceutical Council</p>
            </div>

            <div *ngIf="details?.notificationType === NotificationType.PharmacyRenewalDeclarationMissedForDD">
              <div *ngIf="details?.notificationData?.Count < 6 else showCount">
                <p>Owner name: <b>{{details?.notificationData?.OwnerName}}</b></p>
                <p>Pharmacy renewals outstanding</p>
                <div *ngFor="let premise of details?.notificationData?.Premises; let i = index;">
                  <p>
                    Pharmacy registration number: <b>{{ premise.RegistrationNumber }}</b>
                    <br />
                    Pharmacy name: <b>{{ premise.PremiseName }}</b>
                  </p>
                </div>
              </div>
              <ng-template #showCount>
                <p>Owner name: <b>{{details?.notificationData?.OwnerName}}</b></p>
                <p>Total number of premises for renewal: <b>{{details?.notificationData?.Count}}</b></p>
              </ng-template>
              <p>
                I am writing regarding the direct debit you had in place for the payment of your pharmacy
                registration renewal fees. To collect your renewal fee by direct debit, your annual renewal declarations
                needed to be submitted by <b>{{ details?.notificationData?.DeclarationDeadline }}</b>. As we did not
                receive your declarations by this date, the direct debit instruction has been cancelled, and
                the outstanding renewal fee must now be paid by card or BACS.
              </p>
              <p>
                Please complete the following steps that are still outstanding:
              </p>
              <ul>
                <li>complete your pharmacy renewal declarations </li>
                <li>pay your pharmacy registration renewal fee by card or BACS </li>
              </ul>
              <p>
                If you do not complete your pharmacy renewal declarations and pay your pharmacy
                renewal fee before your renewal due date, your pharmacy registration will be at risk, and
                we may take action that could lead to its removal from the register. If your pharmacy is
                removed, you would need to apply for restoration and pay a higher restoration fee before
                it can be returned to the register.
              </p>
              <p>
                Please note that if you wish to pay by direct debit for your renewal next year, you will need
                to submit a new direct debit mandate. The mandate is available on our website.
              </p>
              <br />
              <p>Regards,</p>
              <p>General Pharmaceutical Council</p>
            </div>

            <div *ngIf="details?.notificationType === NotificationType.PharmacyRenewalPaymentSubmittedForBACS">
              <p>
                To complete your renewal please make a BACS payment for <b>£{{details?.notificationData?.Amount}}</b> with a payment reference of <b>{{details?.notificationData?.OwnerNo}}</b> to:   
              </p>
              <p>Account number: <b>45165548</b></p>
              <p>Sort code: <b>60-60-04</b></p>
              <p>Name of bank: <b>NatWest</b></p>
              <br/>
              <p>Regards,</p>
              <p>General Pharmaceutical Council</p>
            </div>

            <div *ngIf="details?.notificationType === NotificationType.InvitationAcceptedByDelegateUser">
              <p>{{details?.notificationData?.DelegateName}} has accepted the delegate invitation you sent to them for pharmacy owner {{details?.notificationData?.OwnerName}}</p>
            </div>

            <div *ngIf="details?.notificationType === NotificationType.PharmacyExpiryDateReminder">
              <div *ngFor="let premise of details?.notificationData?.Premises; let i = index;">

                <p>
                Pharmacy registration number: <b>{{ premise?.RegistrationNumber }}</b>
                <br /> 
                Pharmacy name: <b>{{ premise?.PremiseName }}</b>
                <br/>
                Pharmacy address: <b>{{ premise?.PremiseAddress }}</b>
                </p>

              </div>

              <p><a [routerLink]="['/owner-details']">Link</a> to Notice of Removal letter.</p>

              <p>You do not appear to have renewed your pharmacy’s entry in the GPhC’s register.</p>
              <p>We must therefore inform you that the pharmacy’s entry will be removed from the register with effect from the day following your registration expiry. 
                This means that you will no longer be able to operate a retail pharmacy from this premises after it’s expiry.</p>
              <p>Please note that it is unlawful under the Pharmacy Order 2010 for an individual, 
                partnership or corporate body to carry out a retail pharmacy business while not entered in the GPhC’s register.</p>
              <p>If you believe that you have already renewed your pharmacy’s registration, please contact our customer services team by calling <b>0203 713 8000</b> or emailing
                <a href="mailto:info@pharmacyregulation.org">info&#64;pharmacyregulation.org.</a>
              </p>
            </div>

        </div>
      </div>
    </div>
  </div>
</div>

  <div *ngIf="notifications" style="padding-bottom: 20px">
    <h4>Notification recipients list:</h4>
    <table class="table">
      <thead>
        <tr>
          <th style="width: 100px">Name</th>
          <th style="width: 200px">User type</th>
          <th style="width: 200px">Notification seen at</th>
        </tr>
      </thead>
      <tbody>
        <tr class="clickable" *ngFor="let notification of notifications ">
          <td> {{ notification.forenames }} {{ notification.surname }}</td>
          <td> {{ getOwnerUserType(notification.ownerUserType) }} </td>
          <td> {{ notification.deactivatedAt | date: 'dd/MM/yyyy hh:mm a' }} </td>
        </tr>
      </tbody>
    </table>

  </div>

  <div *ngIf="!notifications?.length" class="no-data">
    <p *ngIf="!errorMessage">There are currently no notifications to display</p>
    <p *ngIf="!!errorMessage">{{errorMessage}}</p>
  </div>
</div>